import { FAQConstants } from '../constants';
import { FAQService } from '../../services/';
//import { whitelabelObj } from '../../config'

export const FaqActions = {
	fetchFaq,
	
};

function fetchFaq(id) {
	return (dispatch) => {
		dispatch(request());

		FAQService.fetchFaqs(id).then(
			(faqs) => {
				dispatch(success(faqs))
			},
			(error) => dispatch(failure(error.toString()))
		);
	};
}


function request() {
	return { type: FAQConstants.GETFAQ_REQUEST };
}

function success(faqs) {
	return { type: FAQConstants.GETFAQ_SUCCESS, faqs };
	
}

function failure(error) {
	return { type: FAQConstants.GETFAQ_FAILURE, error };
}



// WEBPACK FOOTER //
// ./src/store/actions/faqs.actions.js